<div class="search-field">
  @if (!sidenavCollapsed) {
    <input
      #search
      type="search"
      class="search-field-input"
      placeholder="{{ 'global.search' | translate }}"
      (keyup)="onInputChange(search.value)"
      (keyup.enter)="onInputKeypress($event)"
      />
  }

  <span class="search-field-icon" [class.disabled]="(searchTerms | async) === null">
    <mat-icon class="search-icon">search</mat-icon>
  </span>

  @if (results && results.length) {
    <div class="search-autocomplete">
      <ul>
        @for (result of results; track result.id; let i = $index) {
          <li class="result-list-item flex-row">
            <a
              [routerLink]="['/project/', result.id]"
              [class.is-selected]="selectedResult === i"
              (click)="onProjectSelected(i, $event)"
              class="result-item-link flex-1 flex-column"
              >
              @if (!result.batchNumber) {
                <span class="result-item">{{ result.manufacturer }}</span>
              }
              <span class="result-item flex-column">
                @if (result.batchNumber) {
                  {{ result.manufacturer }} -
                }
                {{ result.projectName }}
                @if (result.productName) {
                  - {{ result.productName }}
                }
              </span>
              @if (result.batchNumber) {
                <span class="result-item">Charge {{ result.batchNumber }}</span>
              }
            </a>
            <colimo-dashboard-controls
              [resultRow]="i"
              [resultId]="result.id"
              [isInDashboard]="result.inDashboard"
              (operationDone)="onProjectSelected($event.index, $event.evt)"
              >
            </colimo-dashboard-controls>
          </li>
        }
      </ul>
    </div>
  }
</div>
